import React, { useState } from 'react';
import { ReactComponent as GoBackButton } from '../../../assets/svg/GoBackButton.svg';
import MDEditor from '@uiw/react-md-editor';

function ExtraSuggestionScreen({ setCurrentMode, currentTopic }: { setCurrentMode: any; currentTopic: any }) {
	const [cut, setCut] = useState(3);

	const loadMore = () => {
		setCut((prev) => prev + 3);
	};

	return (
		<div className='w-full px-[20px] py-[10px] h-[calc(100%-54px)] overflow-auto scrollbar-display-none'>
			<div className='flex flex-row justify-between'>
				<div className='cursor-pointer' onClick={() => setCurrentMode('topic')}>
					<GoBackButton />
				</div>
				<p className='font-bold text-[#02393E] text-[20px] leading-[26px] '>{currentTopic?.title}</p>
				<div className='w-[24px] h-[24px]'></div>
			</div>
			<p className='mt-[30px] font-bold text-darkenPurple text-[24px] leading-[31px] text-center'>{currentTopic?.extraSuggestion?.title}</p>
			<div className=''>
				{currentTopic?.extraSuggestion?.suggestions?.slice(0, cut).map((suggestion: any, index: number) => (
					<SingleSuggestion index={index} suggestion={suggestion} key={index} />
				))}
			</div>
			{currentTopic?.extraSuggestion?.suggestions?.length > cut && (
				<div className='flex-1 flex items-center justify-center mt-[35px]'>
					<div className='w-[119px] h-[50px] flex items-center justify-center rounded-full cursor-pointer border border-primaryViolet' onClick={loadMore}>
						<p className='font-bold text-primaryViolet text-[16px] leading-[20px]'>Load More</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default ExtraSuggestionScreen;

const SingleSuggestion = ({ suggestion, index }: { suggestion: any; index: number }) => {
	const [showSuggestion, setShowSuggestion] = useState(index === 0 ?? false);

	return (
		<div className='mt-[30px]'>
			<div
				className={`py-[15px] px-[20px] mx-[5px] flex-1 min-h-[56px]   rounded-[10px]  relative flex items-center justify-center z-[3] mb-[20px] cursor-pointer ${
					showSuggestion ? '-rotate-[1.31deg] bg-primaryViolet' : 'bg-[#ECEDF580]'
				}`}
				style={{ boxShadow: showSuggestion ? '0px 11px 16px 0px #20D4BF33' : '' }}
				onClick={() => setShowSuggestion((prev) => !prev)}
			>
				<MDEditor.Markdown
					style={{ backgroundColor: 'transparent', color: showSuggestion ? '#ffffff' : '#7A7996', fontWeight: 'bold', fontFamily: 'Quicksand', fontSize: 20, textAlign: 'center' }}
					className='preview-list'
					source={suggestion.title}
				/>
				{showSuggestion && <div className={`absolute -bottom-2 left-[70px] w-[20px] h-[20px] rounded-[4px] rotate-45 ${showSuggestion ? ' bg-primaryViolet' : 'bg-[#ECEDF580]'}`}></div>}
			</div>
			{showSuggestion &&
				suggestion?.steps?.map((step: any, stepIndex: number) => (
					<div className='mb-[10px] border border-[#F2F6FF] py-[15px] px-[10px] rounded-[10px]' key={stepIndex}>
						<MDEditor.Markdown
							style={{ backgroundColor: 'transparent', color: '#02393E', fontSize: 16, textAlign: 'center', fontFamily: 'Quicksand' }}
							className='preview-list'
							source={step.title}
						/>
					</div>
				))}
		</div>
	);
};
